import { useGetUserQuery } from '@/api/piloteer';
import { useAppSelector } from '@/store/hooks';
import { UserRole } from '@/types/user';

export const useUserRole = () => {
  const { session } = useAppSelector((state) => state.auth);

  // Get user data from backend API
  const { data: backendUser } = useGetUserQuery(undefined, {
    skip: !session, // Only fetch when we have a session
  });

  const role = backendUser?.role;
  const company = backendUser?.company;
  const teams = backendUser?.teams || [];

  return {
    role,
    isPerformancePartner: backendUser?.isPerformancePartner === true,
    company,
    teams,
    isChannelPartnerAdmin: role === UserRole.CHANNEL_PARTNER_ADMIN,
    isCompanyAdmin: role === UserRole.COMPANY_ADMIN,
    isCompanyManager: role === UserRole.COMPANY_MANAGER,
    isCompanyMember: role === UserRole.COMPANY_MEMBER,
    hasRole: (requiredRole: UserRole) => role === requiredRole,
    hasAnyRole: (roles: UserRole[]) => roles.includes(role as UserRole),
  };
};
